import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5bbb6564&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb6564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbb6564')) {
      api.createRecord('5bbb6564', component.options)
    } else {
      api.reload('5bbb6564', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5bbb6564&scoped=true&", function () {
      api.rerender('5bbb6564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket2/ticketPublish/Index.vue"
export default component.exports